export enum BulkMode {
  Attachment = 'attachment',
  Bill = 'bill',
}
